module.exports = __webpack_public_path__ + "img/5.05.thmb.61c1b945.jpg";